
define('text!modules/util/buttons/buttons_item_template.html',[],function () { return '<li></li>\r\n';});

